/**
 * Maximum shift period, current setting: 24 hours
 */
export const maximumShiftPeriodInHours = 24;

/**
 * Minimum shift period, current setting: 1 hours
 */
export const minimumShiftPeriodInHours = 1;

/**
 * Hour of day for the Shift to start. i.e. 7:00AM (07:00).
 */
export const defaultShiftStartHourOfDay = 7;

/**
 * Hour of day for the Shift to end. i.e. 7:00PM (19:00).
 */
export const defaultShiftEndHourOfDay = 19;

/**
 * Milliseconds per day.
 */
export const millisecondsPerDay = 86400000;

export const millisecondsPerMinute = 60 * 1000;

export const minutesPerDay = 1440;

export const minutesPerHour = 60;

// Used to correct the right-displacement of the shift button in the table.
export const shiftDivOffsetPx = 2;
